<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>利润表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-date-picker v-model="keywords.years" @change="clicksearch" type="month" placeholder="选择年月" class="select" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickcaiwu" v-if="SubRule_Caiwu_ErpLiRunBiaoAdd">财务填入</el-button>
            <el-button type="success" plain @click="clickunfold">{{unfolds}}</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataListDisplay" :cell-style="{padding: '0'}" border stripe>
          <el-table-column prop="Name" label="" width="250px"></el-table-column>
          <el-table-column prop="Monthvalue" :label="keywords.years" width="250px"></el-table-column>
          <el-table-column prop="Yearvalue" label="年累计" width="250px"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 弹出框 -->
    <el-dialog :title="addForm.years" :visible.sync="adddialog" width="700px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" label-width="250px">
        <el-form-item label="主营业务成本" class="addAdminForm">
          <el-input v-model="addForm.zhuyingyewuchengben"></el-input>
        </el-form-item>
        <el-form-item label="主营业务税金及附加" class="addAdminForm">
          <el-input v-model="addForm.zhuyingyewushui"></el-input>
        </el-form-item>
        <el-form-item label="其他业务支出" class="addAdminForm">
          <el-input v-model="addForm.qitayewuzhichu"></el-input>
        </el-form-item>
        <el-form-item label="租赁费" class="addAdminForm">
          <el-input v-model="addForm.zulingfie"></el-input>
        </el-form-item>
        <el-form-item label="其他非当期支付费用" class="addAdminForm">
          <el-input v-model="addForm.qitafeidangqi"></el-input>
        </el-form-item>
        <el-form-item label="手续费" class="addAdminForm">
          <el-input v-model="addForm.shouxufei"></el-input>
        </el-form-item>
        <el-form-item label="利息收入" class="addAdminForm">
          <el-input v-model="addForm.lixishouru"></el-input>
        </el-form-item>
        <el-form-item label="税收返还、政府奖励等营业外收入" class="addAdminForm">
          <el-input v-model="addForm.shuishoufanhuan"></el-input>
        </el-form-item>
        <el-form-item label="罚款支出等营业外支出" class="addAdminForm">
          <el-input v-model="addForm.fakuanzhichu"></el-input>
        </el-form-item>
        <el-form-item label="所得税" class="addAdminForm">
          <el-input v-model="addForm.suodeshui"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="SaveCaiwu">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 弹出框 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyReportLiRun',
  data () {
    return {
      activeName: 'first',
      addForm: {
        years: '',
        zhuyingyewuchengben: 0,
        zhuyingyewushui: 0,
        qitayewuzhichu: 0,
        zulingfie: 0,
        qitafeidangqi: 0,
        shouxufei: 0,
        lixishouru: 0,
        shuishoufanhuan: 0,
        fakuanzhichu: 0,
        suodeshui: 0
      },
      // 查询
      keywords: {
        years: ''
      },
      adddialog: false,
      unfold: false,
      unfolds: '展开',
      dataList: [],
      dataListDisplay: [],
      SubRule_Caiwu_ErpLiRunBiaoAdd: false
    }
  },
  mounted () {
    this.keywords.years = Vue.prototype.FunGetTimeStringYM()
    this.apiErpLiRunBiaoList()
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Caiwu_ErpLiRunBiaoAdd', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Caiwu_ErpLiRunBiaoAdd = true
      }
    })
  },
  methods: {
    clickcaiwu () {
      this.addForm.years = this.keywords.years
      this.addForm.zhuyingyewuchengben = this.dataList[1].Monthvalue
      this.addForm.zhuyingyewushui = this.dataList[2].Monthvalue
      this.addForm.qitayewuzhichu = this.dataList[5].Monthvalue
      this.addForm.zulingfie = this.dataList[13].Monthvalue
      this.addForm.qitafeidangqi = this.dataList[18].Monthvalue
      this.addForm.shouxufei = this.dataList[19].Monthvalue
      this.addForm.lixishouru = this.dataList[20].Monthvalue
      this.addForm.shuishoufanhuan = this.dataList[22].Monthvalue
      this.addForm.fakuanzhichu = this.dataList[23].Monthvalue
      this.addForm.suodeshui = this.dataList[25].Monthvalue

      this.adddialog = true
    },
    SaveCaiwu () {
      this.apiAddLiRunBiao()
    },
    clicksearch () {
      this.apiErpLiRunBiaoList()
    },
    clickunfold () {
      this.unfold = !this.unfold
      if (this.unfold) {
        this.unfolds = '收缩'
      } else {
        this.unfolds = '展开'
      }
      this.ProcessdataListDisplay()
    },
    ProcessdataListDisplay () {
      var that = this
      that.dataListDisplay = []
      that.dataList.forEach((elem, index) => {
        if (index <= 6 || index >= 19) {
          that.dataListDisplay.push(elem)
        } else {
          if (that.unfold) {
            that.dataListDisplay.push(elem)
          }
        }
      })
    },
    apiErpLiRunBiaoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        years: that.keywords.years
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ErpLiRunBiaoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.ProcessdataListDisplay()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddLiRunBiao: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        years: that.addForm.years,
        zhuyingyewuchengben: that.addForm.zhuyingyewuchengben,
        zhuyingyewushui: that.addForm.zhuyingyewushui,
        qitayewuzhichu: that.addForm.qitayewuzhichu,
        zulingfie: that.addForm.zulingfie,
        qitafeidangqi: that.addForm.qitafeidangqi,
        shouxufei: that.addForm.shouxufei,
        lixishouru: that.addForm.lixishouru,
        shuishoufanhuan: that.addForm.shuishoufanhuan,
        fakuanzhichu: that.addForm.fakuanzhichu,
        suodeshui: that.addForm.suodeshui
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddLiRunBiao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.adddialog = false
            that.apiErpLiRunBiaoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
